module.exports = __webpack_public_path__ + "static/media/metralhas.6cbc8a46.png";